import { Overlay } from '@american-autonomy/ag-ui';

import ApplicationsAccordion from 'components/ApplicationsAccordion';
import ConfirmationModal from 'components/ConfirmationModal';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewPageContainer from 'components/DetailsViewPageContainer';
import LinkedEntitiesAccordion from 'components/LinkedEntitiesAccordion';
import UpdateDroneForm from 'components/forms/UpdateDroneForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { CARD_HEADER_DETAIL_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneDetailsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        applications,
        currentDrone,
        dropdownMenuItems,
        entitiesLink,
        handleClose,
        handleEditClose,
        handleModalClose,
        handleModalConfirm,
        handleSelectApplication,
        handleToggleApplications,
        handleToggleLinkedEntities,
        isApplicationsLoading,
        isApplicationsOpen,
        isClosing,
        isEditing,
        isLinkedEntitiesOpen,
        isLoading,
        modalConfig,
        selectedApplicationId,
        selectedBoundaryGeometry,
        setIsClosing
    } = useData();

    const { APPLICATIONS, LINKED_ENTITIES } = useTranslation();

    return (
        <>
            <DetailsViewPageContainer
                geometry={selectedBoundaryGeometry}
                handleClose={handleClose}
                testId={testId}>
                <DetailsViewCardHeader
                    detailType={CARD_HEADER_DETAIL_TYPE}
                    isLoading={isLoading}
                    items={dropdownMenuItems}
                    name={currentDrone?.name ?? ''}
                />

                {isEditing ? (
                    <UpdateDroneForm
                        formValues={currentDrone}
                        isClosing={isClosing}
                        onClose={handleEditClose}
                        setIsClosing={setIsClosing}
                    />
                ) : (
                    <>
                        <LinkedEntitiesAccordion
                            entitiesLink={entitiesLink}
                            isOpen={isLinkedEntitiesOpen}
                            label={LINKED_ENTITIES}
                            onToggle={handleToggleLinkedEntities}
                        />

                        <ApplicationsAccordion
                            applications={applications}
                            isLoading={isApplicationsLoading}
                            isOpen={isApplicationsOpen}
                            label={APPLICATIONS}
                            onSelectApplication={handleSelectApplication}
                            onToggle={handleToggleApplications}
                            selectedApplicationId={selectedApplicationId}
                        />
                    </>
                )}
            </DetailsViewPageContainer>

            {modalConfig && (
                <Overlay className={styles.modal}>
                    <ConfirmationModal
                        confirmText={modalConfig.confirmText}
                        confirmVariant={modalConfig.confirmVariant}
                        onBack={handleModalClose}
                        onConfirm={handleModalConfirm}
                        subText={modalConfig.subText}
                        text={modalConfig.text}
                    />
                </Overlay>
            )}
        </>
    );
};

export default DroneDetailsPage;
